import { Dispatch, SetStateAction } from "react";
import AskPromotion from "../_AskPromotion";
import CheckPromotion from "../_CheckPromotion";
import CommonFormProvider from "src/context/Modal/Form/CommonForm.provider";
import { useTranslation } from "react-i18next";

interface ISitePromotionUIProps {
  promotionCode: string;
  setPromotionCode: Dispatch<SetStateAction<string>>;
  startDate: string;
  endDate: string;
  setStartDate: Dispatch<SetStateAction<string>>;
  setEndDate: Dispatch<SetStateAction<string>>;
  isCheckPromotionCode: string;
  setIsCheckPromotionCode: Dispatch<SetStateAction<string>>;
  isRenew: boolean;
  promotionApply: ({
    issueAppList,
    referralId,
  }: {
    issueAppList: string[];
    referralId: string;
  }) => void;
  isApplyDone: boolean;
  isCreateDone: boolean;
  isHasSite: boolean;
  goBack?: () => void;
  goNext?: () => void;
  goPromiton?: () => void;
  productName: string;
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
}

const SitePromotionUI = ({
  promotionCode,
  setPromotionCode,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  isCheckPromotionCode,
  setIsCheckPromotionCode,
  isRenew,
  promotionApply,
  isApplyDone,
  isCreateDone,
  isHasSite,
  goBack,
  goNext,
  goPromiton,
  productName,
  toggleAskPromotionOn,
  setToggleAskPromotionOn,
}: ISitePromotionUIProps) => {
  const { t } = useTranslation();
  return (
    <div className="containerBox">
      <div className="container">
        {isApplyDone ? (
          <div className="site">
            <h3 className="site__title">
              {t("siteType.promotionApply.title")}
            </h3>
            <p className="site__desc">
              {t("siteType.promotionApply.subTitle")}
            </p>
            <div className="trialApply">
              <div className="image" />
            </div>
            {isHasSite ? (
              <div className="applyButton">
                <button
                  type="button"
                  onClick={goBack}
                  className="btn btn-green"
                >
                  {/* 사이트 관리로 이동 */}
                  {t("siteType.promotionApply.goToConsoleBtn")}
                </button>
              </div>
            ) : (
              <div className="applyButton">
                <button
                  type="button"
                  onClick={goPromiton}
                  className="btn btn-green"
                >
                  {t("siteType.promotionApply.goToMainBtn")}
                </button>
              </div>
            )}
          </div>
        ) : isCreateDone ? (
          <div className="site">
            <h3 className="site__title">
              {t("siteType.promotionApplied.title")}
            </h3>
            <p className="site__desc">
              {t("siteType.promotionApplied.subTitle")}
            </p>
            <div className="trialApply">
              <div className="image" />
            </div>
            <div className="createButton">
              <button type="button" onClick={goNext} className="btn btn-green">
                <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
                {t("siteType.promotionApplied.goToMainBtn")}
              </button>
            </div>
          </div>
        ) : (
          <div className="site">
            <h3 className="site__title">
              {!toggleAskPromotionOn
                ? productName + " Cloud Premium"
                : isRenew
                ? t("siteType.premium.continueTitle")
                : t("siteType.premium.askTitle")}
            </h3>
            <p className="site__desc">
              {!toggleAskPromotionOn
                ? t("siteType.premium.subTitle")
                : isRenew
                ? t("siteType.premium.continueSubTitle")
                : t("siteType.premium.askSubTitle")}
            </p>
            <div>
              {toggleAskPromotionOn ? (
                // <CommonFormProvider>
                <AskPromotion
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  toggleAskPromotionOn={toggleAskPromotionOn}
                  setToggleAskPromotionOn={setToggleAskPromotionOn}
                />
              ) : (
                // </CommonFormProvider>
                <CommonFormProvider>
                  <CheckPromotion
                    promotionCode={promotionCode}
                    setPromotionCode={setPromotionCode}
                    isCheckPromotionCode={isCheckPromotionCode}
                    toggleAskPromotionOn={toggleAskPromotionOn}
                    setToggleAskPromotionOn={setToggleAskPromotionOn}
                    setIsCheckPromotionCode={setIsCheckPromotionCode}
                    promotionApply={promotionApply}
                  />
                </CommonFormProvider>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SitePromotionUI;
